export default function AddBodyClassOnPageLoad($DOM, classes) {
	$DOM.win.load(function(){
		$DOM.bodyTag.addClass(classes.PageLoaded);
	});
}